// 언어 옵션 목록 - 기존 select의 모든 옵션 포함
// 수정자: 고동현
// 수정일: 2025.05.22
// 수정내용: 언어 옵션 Value값 변경 (기존: ko -> 변경: 한국어)
export const languageOptions = [
  { value: '한국어', label: '한국어' },
  { value: 'English', label: 'English(영어)' },
  { value: '中文', label: '中文 (중국어)' },
  { value: 'Tiếng Việt', label: 'Tiếng Việt (베트남어)' },
  { value: 'Español', label: 'Español (스페인어)' },
  { value: 'Français', label: 'Français (프랑스어)' },
  { value: 'ภาษาไทย', label: 'ภาษาไทย (태국어)' },
  { value: '日本語', label: '日本語 (일본어)' },
  { value: 'Deutsch', label: 'Deutsch (독일어)' },
  { value: 'Русский', label: 'Русский (러시아어)' },
  { value: 'Português', label: 'Português (포르투갈어)' },
  { value: 'Italiano', label: 'Italiano (이탈리아어)' },
  { value: 'Bahasa Indonesia', label: 'Bahasa Indonesia (인도네시아어)' },
  { value: 'Bahasa Melayu', label: 'Bahasa Melayu (말레이어)' },
  { value: 'Filipino', label: 'Filipino (필리핀어)' },
  { value: 'Nederlands', label: 'Nederlands (네덜란드어)' },
  { value: 'Polski', label: 'Polski (폴란드어)' },
  { value: 'Čeština', label: 'Čeština (체코어)' },
  { value: 'Magyar', label: 'Magyar (헝가리어)' },
  { value: 'Română', label: 'Română (루마니아어)' },
  { value: 'Български', label: 'Български (불가리아어)' },
  { value: 'Hrvatski', label: 'Hrvatski (크로아티아어)' },
  { value: 'Shqip', label: 'Shqip (알바니아어)' },
  { value: 'Македонски', label: 'Македонски (마케도니아어)' },
  { value: 'Монгол', label: 'Монгол (몽골어)' },
  { value: 'Türkçe', label: 'Türkçe (터키어)' },
  { value: 'العربية', label: 'العربية (아랍어)' },
  { value: 'עברית', label: 'עברית (히브리어)' },
  { value: 'Kurdî', label: 'Kurdî (쿠르드어)' },
  { value: 'فارسی', label: 'فارسی (페르시아어)' }
]


export const getLanguageLabelByValue = (value) => {
  const option = languageOptions.find(opt => opt.value === value);
  return option ? option.label : '';
}; 

// 언어명(한국어, English 등) → ISO 639-1 코드 변환 매핑 객체
const languageToISOCode = {
  '한국어': 'ko',
  'English': 'en',
  '中文': 'zh',
  'Tiếng Việt': 'vi',
  'Español': 'es',
  'Français': 'fr',
  'ภาษาไทย': 'th',
  '日本語': 'ja',
  'Deutsch': 'de',
  'Русский': 'ru',
  'Português': 'pt',
  'Italiano': 'it',
  'Bahasa Indonesia': 'id',
  'Bahasa Melayu': 'ms',
  'Filipino': 'fil',
  'Nederlands': 'nl',
  'Polski': 'pl',
  'Čeština': 'cs',
  'Magyar': 'hu',
  'Română': 'ro',
  'Български': 'bg',
  'Hrvatski': 'hr',
  'Shqip': 'sq',
  'Македонски': 'mk',
  'Монгол': 'mn',
  'Türkçe': 'tr',
  'العربية': 'ar',
  'עברית': 'he',
  'Kurdî': 'ku',
  'فارسی': 'fa',
}

// 변환 함수
export function convertLanguageToCode(language) {
  return languageToISOCode[language] || null;
}

// 기존 languageOptions 배열 유지...

/**
 * 현지화된 언어 이름을 영어 이름으로 변환하는 매핑
 */
export const languageToEnglishName = {
  // 아시아 언어
  '한국어': 'Korean',
  'English': 'English',
  '中文': 'Chinese',
  'Tiếng Việt': 'Vietnamese',
  'ภาษาไทย': 'Thai',
  '日本語': 'Japanese',
  'Монгол': 'Mongolian',
  'Bahasa Indonesia': 'Indonesian',
  'Bahasa Melayu': 'Malay',
  'Filipino': 'Filipino',
  
  // 유럽 언어
  'Español': 'Spanish',
  'Français': 'French',
  'Deutsch': 'German',
  'Русский': 'Russian',
  'Português': 'Portuguese',
  'Italiano': 'Italian',
  'Nederlands': 'Dutch',
  'Polski': 'Polish',
  'Čeština': 'Czech',
  'Magyar': 'Hungarian',
  'Română': 'Romanian',
  'Български': 'Bulgarian',
  'Hrvatski': 'Croatian',
  'Shqip': 'Albanian',
  'Македонски': 'Macedonian',
  'Türkçe': 'Turkish',
  
  // 중동 언어
  'العربية': 'Arabic',
  'עברית': 'Hebrew',
  'Kurdî': 'Kurdish',
  'فارسی': 'Persian'
};